import { useDispatch } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { HiDotsHorizontal } from "react-icons/hi";
import { FaCalendarDay } from "react-icons/fa";

import { CustomLoader } from '../../../services/Reducer'
import Add_table from '../Fee_Collection_Temp/Add_table.js'
import Edit from '../Fee_Collection_Temp/Edit.js'
import Delete from '../../../components/Delete.js';
import apiClient from '../../../api/apiClient.js';
import { RiFileExcel2Line } from 'react-icons/ri';

const FeeCollectionTempTable = () => {

  const [LogicalFlag, setLogicalFlag] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
  };


  //***************************************  this is for Edit modal *************************************************

  const [editModal, seteditModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const toggleeditModal = (invoiceId) => {
    setSelectedInvoice(invoiceId);
    seteditModal(!editModal);
  };


  //**************************** GetAll Data Fetch ka function *******************************************************

  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const loader = (display) => { dispatch(CustomLoader(display)) }

  const [Records, setRecords] = useState([]);

  const [currentPage, setCurrentPage] = useState(0); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total pages
  const itemsPerPage = 10; // Number of items per page


  const fetchRecords = async (page) => {

    try {

      loader('enable');
      const response = await apiClient.get(`/api/admin/fee_collection_temp/getAll?pageNumber=${page}&pageSize=${itemsPerPage}`);
      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);
      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      loader('disable');
    }

  };

  // Date Picker useEffect
  useEffect(() => {
    loader('disable');

    if (inputRef.current) {
      const fp = flatpickr(inputRef.current, {
        mode: "range",
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            setSelectedDate(selectedDates); // Set the selected date range

            setLogicalFlag(true);
          }
        },
      });

      return () => {
        fp.destroy();
      };


    }
  }, []);


  // Pagination handlers
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage); // Update page
  };


  // Pagination component
  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];

    // Add first 2 pages
    for (let i = 0; i < Math.min(2, totalPages); i++) {
      pages.push(i);
    }

    // Add the current page if it's between first 2 and last 2 pages
    if (currentPage > 1 && currentPage < totalPages - 2) {
      pages.push(currentPage);
    }

    // Add last 2 pages
    for (let i = Math.max(totalPages - 2, 2); i < totalPages; i++) {
      pages.push(i);
    }


    // Previous button condition
    const previousPage = () => {
      if (currentPage > 0) {
        onPageChange(currentPage - 1);
      }
    };

    // Next button condition
    const nextPage = () => {
      if (currentPage < totalPages - 1) {
        onPageChange(currentPage + 1);
      }
    };

    // pagination Buttons Next & Previous
    return (
      <nav>
        <ul className="pagination">

          {/* Previous Button */}
          <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
            <button onClick={previousPage} className="page-link">
              Previous
            </button>
          </li>

          {pages.map((page) => (
            <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
              <button onClick={() => onPageChange(page)} className="page-link">
                {page + 1}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
            <button onClick={nextPage} className="page-link">
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };


  //****************************************  flatpickr code Date filter  ***********************************************


  const itemsPerPages = 10; // Number of items per page
  const [selectedDate, setSelectedDate] = useState([]);


  const [AFFromDate, setAFFromDate] = useState(null);
  const [AFToDate, setAFToDate] = useState(null);


  const formatDate = (date) => {

    if (!date) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;

  };


  const Flatpickr_Filter = async (page) => {

    const fromDate = new Date(selectedDate[0]);
    const toDate = new Date(selectedDate[1]);

    const formattedFromDate = formatDate(fromDate);
    const formattedToDate = formatDate(toDate);

    setAFFromDate(null)
    setAFToDate(null)

    if (LogicalFlag) {
      page = 0;
      setCurrentPage(0);
    }

    try {
      loader('enable');
      const response = await apiClient.get(`/api/admin/fee_collection_temp/DateRangePagedWithPagination?fromDate=${formattedFromDate}&toDate=${formattedToDate}&pageNumber=${page}&pageSize=${itemsPerPages}`
      );

      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);

        setTotalPages(response.data.data.totalPages); // Set total pages from API

        // console.error('date ka deta logs:', data);
      }
      else {
        console.log(response.data.message);

      }
    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      setLogicalFlag(false);
      loader('disable');
    }

  };



  // *******************************************************************************************************************
  // Delete List Records


  const [openModal, setOpenModal] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  const handleDeleteClick = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setOpenModal(true); // Open the modal when delete is clicked
  };

  const handleConfirmDelete = async (invoiceId) => {
    try {
      loader('enable');
      const response = await apiClient.delete(`/api/admin/fee_collection_temp/${selectedInvoiceId}`);
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }

    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    } finally {
      fetchRecords(currentPage);
      loader('disable');
      setOpenModal(false);
    }
  };
  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal if user cancels
  };

  // Excel File Downlode

  const ExcelFileDownload = async () => {
    try {
      loader('enable');
      const response = await apiClient.get(`/api/admin/fee_collection_temp/download`, {
        responseType: 'blob', // Ensures the response is handled as a file (binary)
      });
      if (response.data.Status === "SUCCESS") {

        // Create a link to download the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name you want to download as
        link.setAttribute('download', 'fee_collection_temp.xlsx'); // Change the file name if needed
        document.body.appendChild(link);
        link.click();

        // Clean up the link element
        link.remove();
      }
      else {
        console.log(response.data.message)
      }

    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      loader('disable');
    }
  };



  //*************************************  This is for Advance filter **************************************************

  const [FilterModal, setFilterModal] = useState(false);

  const [selectedOption, setselectedOption] = useState(null);
  const [inputValue, setinputValue] = useState(null);

  const toggleFilterModal = () => {
    setFilterModal(!FilterModal);
  };

  const handleSendDataToParent = (fromDate, toDate, column, value) => {
    setAFFromDate(fromDate)
    setAFToDate(toDate)
    setselectedOption(column)
    setinputValue(value)

    setSelectedDate([]);
    setLogicalFlag(true);

  };


  const applyFilter = async (page) => {

    if (LogicalFlag) {
      page = 0;
      setCurrentPage(0);
    }


    try {
      loader('enable');
      const pageNumber = page;
      const pageSize = 10;

      const fromDate = AFFromDate;
      const toDate = AFToDate;
      const column = selectedOption;
      const value = inputValue;

      const response = await apiClient.get(`/api/admin/fee_collection_temp/filter`, {
        params: {
          pageNumber,
          pageSize,
          fromDate,
          toDate,
          column,
          value,
        },

      });
      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);


      }
      else {
        console.log(response.data.message)
      }
    }

    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      setLogicalFlag(false);
      loader('disable');
    }

  };

  // console.log("current page : ", currentPage);


  useEffect(() => {

    if (selectedDate[0] && selectedDate[1]) {
      Flatpickr_Filter(currentPage);

    }
    else if (AFFromDate && AFToDate) {
      applyFilter(currentPage);

    }
    else {
      fetchRecords(currentPage);

    }
  }, [currentPage, AFFromDate, AFToDate, selectedDate]);


  // **********************************************************************************************************************

  const displayedData = Records;

  // *************************************************  This For CheckBox  **********************************************************

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = displayedData.map(invoice => invoice.id);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (event, id) => {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter(item => item !== id));
    }
  };

  return (

    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-sm">
                <div className="mb-4">

                  <Add_table show={showModal} toggle={toggleModal} refreshData={fetchRecords} AddcurrentPage={currentPage} />
                  <Edit edit={editModal} toggle_Edit={toggleeditModal} invoiceId={selectedInvoice}
                    refreshData={fetchRecords} AddcurrentPage={currentPage} />

                  <button
                    onClick={toggleModal}
                    type="button"
                    className="btn btn-light waves-effect waves-light"
                  >

                    + ADD
                  </button>

                </div>
              </div>
              <div className="col-sm-auto">
                <div className="d-flex align-items-center gap-1 mb-4">
                  <div className="input-group datepicker-range">
                    <input
                      ref={inputRef} // Attach the ref to the input element
                      className="form-control flatpickr-input input"
                      type="text"
                      placeholder="Select Date Range"
                    />
                    <button className="input-group-text" id="date1" data-toggle="">
                      < FaCalendarDay />
                    </button>
                  </div>
                  <div className="dropdown">
                    <a
                      className="btn btn-link text-muted py-1 font-size-16 shadow-none dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      < HiDotsHorizontal />
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <a className="dropdown-item" href="#">
                          Action
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Another action
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Something else here
                        </a>
                      </li>
                      <li>
                        <button className="dropdown-item" onClick={ExcelFileDownload}>
                          <RiFileExcel2Line
                            style={{
                              fontSize: '20px',
                              marginLeft: '-0.50vw',
                              marginRight: '0.50vw',
                              marginTop: '-0.10vw',
                            }}
                          />
                          Excel File Download
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* end row */}
            <div className="table-responsive ">
              <table
                className="table table-bordered align-middle datatable dt-responsive table-check nowrap text-center"
                style={{
                  borderCollapse: "collapse",
                  borderSpacing: "0 8px",
                  width: "100%"
                }}
              >
                <thead className='table-light'>
                  <tr className="bg-transparent">
                    <th style={{ width: 5 }}>
                      <div className="form-check font-size-16">
                        <input
                          type="checkbox"
                          name="check"
                          className="form-check-input"
                          id="checkAll"
                          onChange={handleSelectAll}
                          checked={selectedItems.length === displayedData.length}
                        />
                        <label className="form-check-label" htmlFor="checkAll" />
                      </div>
                    </th>
                    {/* <th style={{ width: 100 }}>_ID_</th> */}
                    <th style={{ width: 100 }}>portId</th>
                    <th style={{ width: 100 }}>operatorId</th>
                    <th style={{ width: 100 }}>portTypeId</th>
                    <th style={{ width: 100 }}>feeTypeId</th>
                    <th style={{ width: 100 }}>commodityId</th>
                    <th style={{ width: 100 }}>subCommodityId</th>
                    <th style={{ width: 100 }}>subSubCommodityId</th>
                    <th style={{ width: 100 }}>vesselId</th>
                    <th style={{ width: 100 }}>imoNumber</th>
                    <th style={{ width: 100 }}>portOfRegistry</th>
                    <th style={{ width: 100 }}>officialNumber</th>
                    <th style={{ width: 100 }}>flag</th>
                    <th style={{ width: 100 }}>coastal</th>
                    <th style={{ width: 100 }}>dwt</th>
                    <th style={{ width: 100 }}>grt</th>
                    <th style={{ width: 100 }}>nrt</th>
                    <th style={{ width: 100 }}>arrivalDate</th>
                    <th style={{ width: 100 }}>commencementDate</th>
                    <th style={{ width: 100 }}>departureDate</th>
                    <th style={{ width: 100 }}>transhipment</th>
                    <th style={{ width: 100 }}>lastPortCall</th>
                    <th style={{ width: 100 }}>nextPortCall</th>
                    <th style={{ width: 100 }}>completionDate</th>
                    <th style={{ width: 100 }}>supportingDoc</th>
                    <th style={{ width: 100 }}>rate</th>
                    <th style={{ width: 100 }}>quantity</th>
                    <th style={{ width: 100 }}>total</th>
                    <th style={{ width: 100 }}>penaltyDays</th>
                    <th style={{ width: 100 }}>penaltyAmount</th>
                    <th style={{ width: 100 }}>penaltyTotal</th>
                    <th style={{ width: 100 }}>grandTotal</th>
                    <th style={{ width: 100 }}>tds</th>
                    <th style={{ width: 100 }}>cgst</th>
                    <th style={{ width: 100 }}>sgst</th>
                    <th style={{ width: 100 }}>igst</th>
                    <th style={{ width: 100 }}>finalAmount</th>
                    <th style={{ width: 100 }}>paymentMode</th>
                    <th style={{ width: 100 }}>paymentStatus</th>

                    <th style={{ width: 100 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedData.length > 0 ? (
                    <>
                      {displayedData.map(invoice => (
                        <tr key={invoice.id}>
                          <td>
                            <div className="form-check font-size-16">
                              <input type="checkbox" className="form-check-input" />
                              <label className="form-check-label" />
                            </div>
                          </td>
                          {/* <td>
                            <a
                              className="text-body fw-medium"
                            >{invoice.id}
                            </a>
                          </td> */}
                          <td>{invoice?.port || '--'}</td>
                          <td>{invoice?.operator || '--'}</td>
                          <td>{invoice?.portType || '--'}</td>
                          <td>{invoice?.feeType || '--'}</td>
                          <td>{invoice?.commodity || '--'}</td>
                          <td>{invoice?.subCommodity || '--'}</td>
                          <td>{invoice?.subSubCommodity || '--'}</td>
                          <td>{invoice?.vessel || '--'}</td>
                          <td>{invoice?.imoNumber || '--'}</td>
                          <td>{invoice?.portOfRegistry || '--'}</td>
                          <td>{invoice?.officialNumber || '--'}</td>
                          <td>{invoice?.flag || '--'}</td>
                          <td>{invoice?.coastal || '--'}</td>
                          <td>{invoice?.dwt || '--'}</td>
                          <td>{invoice?.grt || '--'}</td>
                          <td>{invoice?.nrt || '--'}</td>
                          <td>{invoice?.arrivalDate || '--'}</td>
                          <td>{invoice?.commencementDate || '--'}</td>
                          <td>{invoice?.departureDate || '--'}</td>
                          <td>{invoice?.transhipment || '--'}</td>
                          <td>{invoice?.lastPortCall || '--'}</td>
                          <td>{invoice?.nextPortCall || '--'}</td>
                          <td>{invoice?.completionDate || '--'}</td>
                          <td>{invoice?.supportingDoc || '--'}</td>
                          <td>{invoice?.rate || '--'}</td>
                          <td>{invoice?.quantity || '--'}</td>
                          <td>{invoice?.total || '--'}</td>
                          <td>{invoice?.penaltyDays || '--'}</td>
                          <td>{invoice?.penaltyAmount || '--'}</td>
                          <td>{invoice?.penaltyTotal || '--'}</td>
                          <td>{invoice?.grandTotal || '--'}</td>
                          <td>{invoice?.tds || '--'}</td>
                          <td>{invoice?.cgst || '--'}</td>
                          <td>{invoice?.sgst || '--'}</td>
                          <td>{invoice?.igst || '--'}</td>
                          <td>{invoice?.finalAmount || '--'}</td>
                          <td>{invoice?.paymentMode || '--'}</td>
                          <td>{invoice?.paymentStatus || '--'}</td>
                          <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                < HiDotsHorizontal />
                              </button>
                              <ul className="dropdown-menu dropdown-menu-end">
                                <li>

                                  <button
                                    onClick={() => toggleeditModal(invoice.id)}
                                    type="button"
                                    className="btn waves-effect waves-light dropdown-item"
                                  >

                                    <i className="dropdown-item" /> Edit
                                  </button>

                                </li>

                                <li>
                                  <button className="btn waves-effect waves-light dropdown-item"
                                    onClick={() => handleDeleteClick(invoice.id)}
                                  >
                                    Delete
                                  </button>
                                  <Delete
                                    open={openModal}
                                    handleClose={handleCloseModal}
                                    handleConfirm={handleConfirmDelete}
                                    message="Are you sure you want to delete this invoice ?"
                                  />
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={8}>
                        <p className="text-center" >Record Not Found</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* end table responsive */}
            <div className='d-flex flex-row justify-content-end'>
              Showing {currentPage + 1} In to {totalPages} Entries
            </div>
            {/* Pagination */}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />

          </div>
          {/* end card body */}
        </div>
        {/* end card */}
      </div>
      {/* end col */}
    </div>

  );
};

export default FeeCollectionTempTable;
